<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>

                <CCardBody>
                    <AssistantServiceTabLinks />

                    <div class="flex items-center mt-4">
                        <span class="w-1/3 font-bold">Название</span>
                        <span class="w-2/3">{{ entity.title }}</span>
                    </div>

                    <div class="flex items-center mt-4">
                        <span class="w-1/3 font-bold">Краткое описание</span>
                        <span class="w-2/3">{{ entity.description }}</span>
                    </div>

                    <div class="flex items-center mt-4">
                        <span class="w-1/3 font-bold">Цена</span>
                        <span class="w-2/3">{{ entity.price }}</span>
                    </div>

                    <div class="flex items-start mt-4">
                        <span class="w-1/3 font-bold">Картинки</span>
                        <div class="flex flex-wrap w-2/3 mt-2 -ml-2">
                            <div
                                v-for="item in entity.pictures"
                                :key="item"
                                class="w-1/4 p-2"
                            >
                                <div
                                    class="relative w-full overflow-hidden bg-no-repeat bg-cover rounded-md shadow-md group-hover"
                                    :style="{
                                        paddingTop: '100%',
                                        backgroundImage: `url(${getStaticPath(item)})`,
                                        backgroundPosition: 'center center',
                                    }"
                                >
                                    <div
                                        v-if="entity.main_picture === item"
                                        class="absolute inset-x-0 bottom-0 flex items-center h-10 px-1 text-green-500 bg-black bg-opacity-75"
                                    >
                                        <CIcon :height="20" :content="cilCheckCircle" />
                                        <span class="ml-2 text-xs">Основная картинка</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex items-center mt-4">
                        <span class="w-1/3 font-bold">Популярный</span>
                        <span class="w-2/3">
                            <CBadge :color="entity.popular ? 'success' : 'secondary'">
                                <span class="px-1">{{ entity.popular ? "Да" : "Нет" }}</span>
                            </CBadge>
                        </span>
                    </div>

                    <div class="flex items-center mt-4">
                        <span class="w-1/3 font-bold">Активен</span>
                        <span class="w-2/3">
                            <CBadge :color="entity.enabled ? 'success' : 'secondary'">
                                <span class="px-1">{{
                                    entity.enabled ? "Активен" : "Неактивен"
                                }}</span>
                            </CBadge>
                        </span>
                    </div>

                    <div class="flex items-center mt-4">
                        <span class="w-1/3 font-bold">Положение в списке</span>
                        <span class="w-2/3">{{ entity.position }}</span>
                    </div>
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="secondary"
                        @click="$router.push(`/assistants/${$route.params.id}/service`)"
                    >Назад к списку
                    </CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import to from 'await-to-js';
    import { morphism } from 'morphism';
    import { cilCheckCircle } from '@coreui/icons';

    import AssistantServiceTabLinks from '@/components/assistant/AssistantServiceTabLinks';

    export default {
        components: {
            AssistantServiceTabLinks,
        },

        data() {
            return {
                cilCheckCircle,
                entity: undefined,
                schema: {
                    title: 'title',
                    description: 'description',
                    main_picture: 'main_picture',
                    price: 'price',
                    assistant_id: () => this.$route.params.id,
                    position: source => (parseInt(source.position) ? source.position : 1),
                    pictures: source =>
                        Array.isArray(source.pictures) ? source.pictures : [],
                    popular: source => source.popular || false,
                    enabled: source => source.enabled || false,
                },
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id, service_id } = this.$route.params;

                const [error, result] = await to(
                    this.axios.get(`/assistants/${id}/services/${service_id}`)
                );
                this.entity = morphism(this.schema, result.data);

                if (error) {
                    return this.$root.$emit('showError', 'Невозможно получить товар.');
                }
            },

            getStaticPath(filename = '') {
                if (filename.startsWith('http')) {
                    return filename;
                }

                return `${process.env.VUE_APP_STATIC_BASE_URL}/${filename}`;
            },
        },
    };
</script>
